import React, { useEffect, useState } from 'react';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import styles from "./scss/initialcheck.module.scss";
import { Row, Col, Dropdown, Modal, Button, Accordion, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useNavigate } from 'react-router';
import { useForm } from "react-hook-form";
import axios from 'axios';
import { API_ROUTE_CONTROLLER } from '../../../app/base/routes';
import { ApiServices } from "../../../app/base/service/apiService";
import { useDispatch } from 'react-redux';
import Select, { components } from 'react-select';
import { useSelector } from 'react-redux';
import cancelbtn from '../../../styles/images/cancelbtn.svg';
import InitialChecks from '../../Portin/Portnumber/initialchecks';

const SipRules = (props: any) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const login = useSelector((state: any) => state.login.login);
    const trunkInfo = useSelector((state: any) => state.siptrunk.trunkInfo);
    const trunkNumbers = useSelector((state: any) => state.siptrunk.didNumbers);
    const didsString = trunkNumbers.filter((tag: any) => tag.trim() !== '').join(', ');

    console.log("didsString", trunkInfo, trunkNumbers, didsString)
    const trunkInfoIps = useSelector((state: any) => state.siptrunk.providerIp);
    const [inputList, setInputList] = useState([{ prefix: "", didNo: "", pre_array: [] }]);
    const [outboundList, setOutboundList] = useState([{ prefix: "", didNo: "", pre_array: [] }]);
    const [selectedValues, setSelectedValues] = useState<any>([]);
    const hideCallerID = selectedValues.map((item: any) => item.value).join(', ');
    const { handleSubmit: handleSubmit, register: register, formState: { errors: errors }, reset: reset } = useForm();
    const editTrunkId = useSelector((state: any) => state.siptrunk.editTrunkId);

    const handlePrifixChange = (event, index) => {
        const data = [...inputList];
        data[index].prefix = event.target.value;
        setInputList(data);
    };

    const handleKeyDown = (event, index) => {
        if (event.key === 'Enter' || event.key === ' ' || event.key === ',' || event.key === '-') {
            event.preventDefault();
            const data: any = [...inputList];
            const trimmedPrefix = data[index].prefix.trim();

            if (trimmedPrefix) {
                if (data[index].pre_array.includes(trimmedPrefix)) {
                    alert("Already Exists")
                } else {
                    data[index].pre_array.push(trimmedPrefix);
                    data[index].prefix = '';
                    setInputList(data);
                }
            }
        }
    };

    const outputArray = inputList.map((item: any) => {
        const prefixes = item.prefix;
        const didNumbers = item?.did?.map(did => did.value).join(',');

        return {
            Prefix: prefixes,
            DIDNumber: didNumbers
        };
    });
    const outArr = JSON.stringify(outputArray);

    const nextPage = (data) => {
        insertSipTrunk();
    }

    const upDateApi = (data) => {
        UpdateSipTrunk();
    }


    const BackPage = () => {
        navigate("/siptrunck/didnumber");
    }

    const clearOption = { value: 'clear', label: 'Clear Selection' };
    const formattedOptions = trunkNumbers.map((option) => ({
        InitialChecks,
        value: option,
        label: option,
        isSelected: selectedValues.some((selected: any) => selected.value === option),
    }));
    formattedOptions.push(clearOption)

    const handleInputChange = (index, key, selectedOptions) => {
        if (selectedOptions.some(option => option.value === 'clear')) {
            const updatedInputList = [...inputList];
            updatedInputList[index][key] = [];
            setInputList(updatedInputList);
        } else {
            const updatedInputList = [...inputList];
            updatedInputList[index][key] = selectedOptions;
            setInputList(updatedInputList);
        }
    };

    // const OptionWithCheckbox = (props) => {
    //     return (
    //         <components.Option {...props}>
    //             <input type="checkbox" checked={props.isSelected} readOnly />
    //             {props.label}
    //         </components.Option>
    //     );
    // };

    const handleRemoveInput = (index) => {
        const updatedInputList = [...inputList];
        updatedInputList.splice(index, 1);
        setInputList(updatedInputList);
    };

    const handleAddClick = () => {
        setInputList([...inputList, { prefix: "", didNo: "", pre_array: [] }]);
    };

    const handleRemoveTag = (index, tagIndex) => {
        const updatedInputList = [...inputList];
        updatedInputList[index].pre_array.splice(tagIndex, 1);
        setInputList(updatedInputList);
    };

    const handleOutBoundChange = (index, key, selectedOptions) => {
        if (selectedOptions.some(option => option.value === 'clear')) {
            const updatedInputList = [...outboundList];
            updatedInputList[index][key] = [];
            setOutboundList(updatedInputList);
        } else {
            const updatedInputList = [...outboundList];
            updatedInputList[index][key] = selectedOptions;
            setOutboundList(updatedInputList);
        }
    };

    const handleRemoveOutbound = (index) => {
        const updatedOutboundList = [...outboundList];
        updatedOutboundList.splice(index, 1);
        setOutboundList(updatedOutboundList);
    };

    const handleAddOutbound = () => {
        setOutboundList([...outboundList, { prefix: "", didNo: "", pre_array: [] }]);
    };

    const handleSelectCallerID = (selectedOptions) => {
        if (selectedOptions.some((option) => option.value === 'clear')) {
            setSelectedValues([]);
        } else {
            setSelectedValues(selectedOptions);
        }
    };

    const outBoundHandleKeyDown = (event, index) => {
        if (event.key === 'Enter' || event.key === ' ' || event.key === ',' || event.key === '-') {
            event.preventDefault();
            const data: any = [...outboundList];
            const trimmedPrefix = data[index].prefix.trim();

            if (trimmedPrefix) {
                if (data[index].pre_array.includes(trimmedPrefix)) {
                    alert("Already Exists")
                } else {
                    data[index].pre_array.push(trimmedPrefix);
                    data[index].prefix = '';
                    setOutboundList(data);
                }
            }
        }
    };

    const outBoundHandlePrifixChange = (event, index) => {
        const data = [...outboundList];
        data[index].prefix = event.target.value;
        setOutboundList(data);
    };

    const outBoundOutputArray = outboundList.map((item: any) => {
        const prefixes = item.prefix;
        const didNumbers = item?.did?.map(did => did.value).join(',');

        return {
            Prefix: prefixes,
            DIDNumber: didNumbers
        };
    });
    const outBoundOutArr = JSON.stringify(outBoundOutputArray);

    const outBoundRemoveTag = (index, tagIndex) => {
        const updatedOutputList = [...outboundList];
        updatedOutputList[index].pre_array.splice(tagIndex, 1);
        setOutboundList(updatedOutputList);
    };

    const ipInsert = (id) => {
        // companyId based IP
        try {
            let _body = {
                "p_company_id": login.company_id
            };
            ApiServices.post(_body, API_ROUTE_CONTROLLER.get_ur_myacc_get_dc_ip).then(async (res: any) => {
                if (res.data.status_code == 200) {
                    redisUpdate(res.data.users[0].DC, id);

                    // IP insert
                    try {
                        let _body = {
                            "p_domain_whitelist": trunkInfo.provider_IP ? trunkInfo.provider_IP : trunkInfoIps,
                            "p_trunkid": id,
                            "p_DC": res.data.users[0].DC
                        };
                        ApiServices.post(_body, API_ROUTE_CONTROLLER.worktual_create_ipdomain_whitelist).then(async (res: any) => {
                            console.log("worktual_create_ipdomain_whitelist", res)

                        })
                    } catch (error) {
                        console.log("API error");
                    }
                }
            })
        } catch (error) {
            console.log("API error");
        }


    }

    const redisUpdate = (dctype, id) => {
        const numberArray = trunkInfoIps.split(',');
        const ipAddrFormat = '["' + numberArray.join('","') + '"]';
        // console.log("ipAddrFormat", JSON.parse(ipAddrFormat.toString()));
        try {
            let _body = {
                "msg_type": "ADD_IP_TO_WHITE_LIST",
                "ip_addr": JSON.parse(ipAddrFormat.toString()),
                "dc_type": dctype,
                "trunk_id": id
            };
            ApiServices.post(_body, API_ROUTE_CONTROLLER.whitelistupdation).then(async (res: any) => {
                console.log("whitelistupdation", res)
                if (res.data.status_code == 200) {

                }
            })
        } catch (error) {
            console.log("API error");
        }
    }

    const insertSipTrunk = () => {
        try {
            let _body = {
                "p_SIPTrunkMasterId": editTrunkId.SIPTrunkMasterId ? editTrunkId.SIPTrunkMasterId : 0,
                "p_CompanyId": login.company_id,
                "p_pk_country_id": trunkInfo.country_name,
                "p_ProviderName": trunkInfo.provider,
                "p_TrunkName": trunkInfo.company_name,
                "p_MainTrunkNumber": trunkInfo.trunk_number,
                "p_AuthUserID": trunkInfo.auth_userId,
                "p_AuthPassword": trunkInfo.auth_password,
                "p_ProviderIPs": trunkInfo.provider_IP ? trunkInfo.provider_IP : trunkInfoIps,
                "p_DIDNumber": didsString,
                "p_InboundCondition": outArr,
                "p_OutboundCondition": outBoundOutArr,
                "p_CallerId": hideCallerID
            };
            ApiServices.post(_body, API_ROUTE_CONTROLLER.get_up_Insert_Update_SIPTrunk).then(async (res: any) => {
                console.log("get_up_Insert_Update_SIPTrunk", res)
                if (res.data.status_code == 200) {
                    if (res.data.users[0].errmsg == "Added SIP Trunk Details") {
                        navigate("/siptrunck");
                        if (!editTrunkId.SIPTrunkMasterId) {
                            didPortalInsert();
                            ipInsert(res.data.users[0].TrunkMasterId);
                        }
                    } else {

                    }
                }
            })
        } catch (error) {
            console.log("API error");
        }
    }

    const UpdateSipTrunk = () => {
        try {
            let _body = {
                "p_SIPTrunkMasterId": editTrunkId.SIPTrunkMasterId ? editTrunkId.SIPTrunkMasterId : 0,
                "p_CompanyId": login.company_id,
                "p_pk_country_id": trunkInfo.country_name,
                "p_ProviderName": trunkInfo.provider,
                "p_TrunkName": trunkInfo.company_name,
                "p_MainTrunkNumber": trunkInfo.trunk_number,
                "p_AuthUserID": trunkInfo.auth_userId,
                "p_AuthPassword": trunkInfo.auth_password,
                "p_ProviderIPs": trunkInfo.provider_IP ? trunkInfo.provider_IP : trunkInfoIps,
                "p_DIDNumber": didsString,
                "p_InboundCondition": outArr,
                "p_OutboundCondition": outBoundOutArr,
                "p_CallerId": hideCallerID
            };
            ApiServices.post(_body, API_ROUTE_CONTROLLER.get_up_Insert_Update_SIPTrunk).then(async (res: any) => {
                console.log("get_up_Insert_Update_SIPTrunk", res)
                if (res.data.status_code == 200) {
                    if (res.data.users[0].errmsg == "Updated SIP Trunk Details") {
                        navigate("/siptrunck");
                        if (!editTrunkId.SIPTrunkMasterId) {
                            didPortalInsert();
                            ipInsert(res.data.users[0].TrunkMasterId);
                        }
                    } else {

                    }
                }
            })
        } catch (error) {
            console.log("API error");
        }
    }

    const didPortalInsert = () => {
        try {
            let _body = {
                "country_id": 29,
                "city_id": "803",
                "operator_id": 7,
                "number_range": "1",
                "did_number_data": trunkInfo.trunk_number
            };
            ApiServices.post(_body, API_ROUTE_CONTROLLER.didnumber_upload_integration).then(async (res: any) => {
                if (res.data.response[0].errmsg == "Succes: Inserted") {
                    // ccaas table insert
                    // try {
                    //     let _body = {
                    //         "ext": 200,
                    //         "domainId": login.domain_id,
                    //         "type": "sip",
                    //         "city": 29,
                    //         "your_number":didsString,
                    //         "isSmsOut": 0,
                    //         "isSmsIn": 0,
                    //         "isCallIn": 1,
                    //         "isCallOut": 1,
                    //     };
                    //     ApiServices.post(_body, API_ROUTE_CONTROLLER.ccaasInsertOnboardDidNumber).then(async (res: any) => {
                    //         if (res.data.status_code == 200) {

                    //         }
                    //     })
                    // } catch (error) {
                    //     console.log("API error");
                    // }
                    trunkNumbers.map((didNumber: any) => {
                        console.log("didnumber", didNumber)
                        try {
                            console.log("inside try")
                            let _body = {
                                "ext": 200,
                                "domainId": login.domain_id,
                                "type": "sip",
                                "city": 29,
                                "your_number": didNumber,
                                "isSmsOut": 0,
                                "isSmsIn": 0,
                                "isCallIn": 1,
                                "isCallOut": 1,
                            };
                            ApiServices.post(_body, API_ROUTE_CONTROLLER.ccaasInsertOnboardDidNumber).then(async (res: any) => {
                                if (res.data.status_code == 200) {

                                }
                            })
                        } catch (error) {
                            console.log("API error");
                        }
                    })
                }
                // }
            })
        } catch (error) {
            console.log("API error");
        }
    }

    useEffect(() => {

        if (editTrunkId.SIPTrunkMasterId) {
            try {
                let _body = {
                    "p_SIPTrunkMasterId": editTrunkId.SIPTrunkMasterId,
                    "p_CompanyId": login.company_id
                };
                ApiServices.post(_body, API_ROUTE_CONTROLLER.get_up_getSipTrunkById).then(async (res: any) => {
                    if (res.data.status_code == 200) {

                        const inBoundRulesEdit = res.data.inBoundPrefix.map((totalUserItem, index) => {
                            const activeDeviceItem = res.data.inBoundDid[index];

                            const prefixArray = totalUserItem.Prefix.split(',').map(item => item.trim());
                            const didNoArray = activeDeviceItem.DIDNumber.split(',').map(item => item.trim());

                            const didArray = didNoArray.map(didNo => ({
                                value: didNo,
                                label: didNo,
                                isSelected: true,
                            }));

                            return {
                                prefix: [],
                                didNo: [],
                                pre_array: prefixArray,
                                did: didArray,
                            };
                        });
                        const formattedJSON = JSON.stringify(inBoundRulesEdit, null, 2);
                        const parsedArray = JSON.parse(formattedJSON);
                        setInputList(parsedArray);

                        const outBoundRulesEdit = res.data.outBoundPrefix.map((totalUser, index) => {
                            const outBoundDid = res.data.outBoundDid[index];
                            const outPrefixArray = totalUser.Prefix.split(',').map(item => item.trim());
                            const outDidNoArray = outBoundDid.DIDNumber.split(',').map(item => item.trim());
                            const outDidArray = outDidNoArray.map(didNo => ({
                                value: didNo,
                                label: didNo,
                                isSelected: true,
                            }));

                            return {
                                prefix: [],
                                didNo: [],
                                pre_array: outPrefixArray,
                                did: outDidArray,
                            };
                        });
                        const outBoundformattedJSON = JSON.stringify(outBoundRulesEdit, null, 2);
                        const outBoundParsedArray = JSON.parse(outBoundformattedJSON);
                        setOutboundList(outBoundParsedArray);

                        const hideCallerId = res.data.users[0].HideCallerId.split(",").map(value => ({
                            value: value.trim(),
                            label: value.trim(),
                            isSelected: true
                        }));
                        setSelectedValues(hideCallerId);
                    }
                })
            } catch (error) {
                console.log("API error");
            }
        } else {

        }
    }, []);


    return (
        <>

            <Row className="breadcrumbarea">
                <Col sm={12}>
                    <h4>SIP Trunk
                        <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.847363 11.6654C0.654963 11.6654 0.462564 11.5922 0.316164 11.4447C0.0236636 11.1517 0.0246635 10.6771 0.318163 10.3842L4.18246 6.53168C4.32456 6.39008 4.40266 6.20058 4.40266 5.99948C4.40266 5.79928 4.32456 5.61078 4.18246 5.46918L0.317764 1.61568C0.0247639 1.32268 0.0238637 0.848079 0.316264 0.555179C0.608264 0.261279 1.08336 0.261279 1.37726 0.553179L5.24156 4.40668C5.66736 4.83148 5.90216 5.39688 5.90266 5.99948C5.90316 6.60208 5.66826 7.16748 5.24156 7.59418L1.37686 11.4467C1.23086 11.5922 1.03876 11.6654 0.847363 11.6654Z" fill="black" />
                        </svg>
                        <span>SIP Add Trunk</span></h4>
                </Col>
            </Row>
            <Row className="nopadding basicinfocheck">
                <Col sm={12} className="nopadding basicinfocheck">
                    <div className={`${styles.porttrunkinfo} ${styles.trunckdidrule}`}>
                        <ul>
                            <li className={styles.activeinflo}>Prefix</li>
                        </ul>
                    </div>
                    <div className={styles.portnumllist}>
                        <ul>
                            <li ><span>1</span>Trunk Info</li>
                            <li><span>2</span>DID Numbers</li>
                            <li className={styles.active}><span>3</span>Prefix</li>
                        </ul>
                    </div>
                    <div className={`${styles.mainscroll}`}>
                            <div className="siptrunckaccordin">
                                            <Accordion defaultActiveKey={["0", "1"]} alwaysOpen>
                                                <Accordion.Item eventKey="0">
                                                    <Accordion.Header>Inbound conditions</Accordion.Header>
                                                    <Accordion.Body>
                                                        {inputList.map((input: any, index) => (
                                                            <div className={`initialcheck ${styles.initialcheck}`}>
                                                                <label className={`${styles.fieldarea} ${styles.fieldareablock}`}>
                                                                    <span>Prefix condition  &nbsp;
                                                                        <OverlayTrigger overlay={<Tooltip>Prefix condition Information</Tooltip>}>
                                                                            <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M6.24012 6.66686C6.44678 6.65353 6.92012 6.64686 7.26012 6.72686C7.50012 6.78686 7.66678 7.00686 7.65345 7.26019C7.64012 7.45353 7.59345 7.70019 7.53345 7.98019C7.44658 8.37111 7.38182 8.7753 7.33917 9.0415C7.32945 9.10211 7.32087 9.15568 7.31345 9.20019C7.26679 9.44019 7.35345 9.83353 7.66012 9.68019C7.96678 9.52686 8.24012 9.42686 8.14678 9.68019C8.06678 9.89353 7.64012 10.2002 7.14679 10.2202C6.65345 10.2402 6.04012 10.0269 6.10678 9.45353C6.15574 9.03252 6.2694 8.42459 6.33954 8.04944C6.36491 7.91374 6.3846 7.80842 6.39345 7.75353C6.39852 7.72213 6.40543 7.68626 6.41283 7.64785C6.45414 7.43347 6.51074 7.13977 6.34679 7.10019C6.29814 7.08845 6.24528 7.08093 6.19298 7.07349C6.03739 7.05135 5.88674 7.02992 5.86679 6.90019C5.84012 6.76686 5.97345 6.67352 6.25345 6.66019L6.24012 6.66686Z" fill="#757676" />
                                                                                <path d="M7.69345 5.47353C7.69345 5.85644 7.38304 6.16686 7.00012 6.16686C6.6172 6.16686 6.30678 5.85644 6.30678 5.47353C6.30678 5.09061 6.6172 4.78019 7.00012 4.78019C7.38304 4.78019 7.69345 5.09061 7.69345 5.47353Z" fill="#757676" />
                                                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.00016 0.833496C3.32016 0.833496 0.333496 3.82016 0.333496 7.50016C0.333496 11.1802 3.32016 14.1668 7.00016 14.1668C10.6802 14.1668 13.6668 11.1802 13.6668 7.50016C13.6668 3.82016 10.6802 0.833496 7.00016 0.833496ZM7.00016 1.8335C10.1268 1.8335 12.6668 4.3735 12.6668 7.50016C12.6668 10.6268 10.1268 13.1668 7.00016 13.1668C3.8735 13.1668 1.3335 10.6268 1.3335 7.50016C1.3335 4.3735 3.8735 1.8335 7.00016 1.8335Z" fill="#757676" />
                                                                            </svg>
                                                                        </OverlayTrigger>
                                                                    </span>
                                                                    <div className={styles.largeblock}>
                                                                        <div className={`inputfield ${styles.textareafield} ${styles.textareatag}`}>
                                                                            <div className="inputfieldflex inputfieldmultitag inputfieldmultitagip">
                                                                                <div className='taginput'>
                                                                                    {inputList[index].pre_array.map((tag, tagIndex) => (<label className="taglabel" >{tag} <span>
                                                                                        <OverlayTrigger overlay={<Tooltip>Remove</Tooltip>}>
                                                                                            <div className='closebtn' onClick={() => handleRemoveTag(index, tagIndex)}>
                                                                                                <img src={cancelbtn} />
                                                                                            </div>
                                                                                        </OverlayTrigger>
                                                                                    </span>
                                                                                    </label>
                                                                                    ))}
                                                                                </div>
                                                                                <input className="errorinput" type="text" placeholder="Enter Condition"
                                                                                    value={inputList[index].prefix}
                                                                                    onKeyDown={(evt) => handleKeyDown(evt, index)}
                                                                                    onChange={(evt) => handlePrifixChange(evt, index)}
                                                                                    onKeyPress={(event) => {
                                                                                        if (!/[0-9*+]/.test(event.key)) {
                                                                                            event.preventDefault();
                                                                                        }
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </label>

                                                                <label className={`${styles.fieldarea}  ${styles.fieldareablock}`}>
                                                                    <span>DID Numbers </span>
                                                                    <div className={styles.largeblock}>
                                                                        <div className={`inputfield ${styles.textareafield} ${styles.regularselectwidth} ${styles.textareatag} ${styles.textarearules}`}>

                                                                            <Select
                                                                                className="regularselect regularselectflex regularselectsiprule"
                                                                                menuShouldScrollIntoView={false}
                                                                                placeholder="Select DID"
                                                                                isMulti
                                                                                //options={[ formattedOptions, { value: 'clear', label: 'Clear Selection' },]}
                                                                                // components={{ Option: OptionWithCheckbox }}
                                                                                options={formattedOptions}
                                                                                // onChange={handleSelectDid}
                                                                                //defaultValue={x.didNo}
                                                                                //onChange={(e) => handleInputChange(e, i)}
                                                                                isSearchable={false}
                                                                                onChange={(selected) => handleInputChange(index, 'did', selected)}
                                                                                value={input.did}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </label>
                                                                <div className={`btn-box ${styles.btnbox}  ${styles.btnboxminus}`}>
                                                                    <span onClick={handleAddClick}>
                                                                        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <rect width="36" height="36" rx="18" fill="#F0F1F2" />
                                                                            <g clip-path="url(#clip0_3731_33051)">
                                                                                <path d="M25.2512 17.2471L18.7444 17.2516V10.7497C18.7444 10.3357 18.4087 10 17.9947 10C17.5807 10 17.245 10.3357 17.245 10.7497V17.2527L10.7472 17.2572C10.3332 17.2574 9.99775 17.5933 9.99805 18.0073C9.99835 18.4214 10.3342 18.7568 10.7482 18.7565L17.245 18.752V25.2539C17.245 25.6679 17.5807 26.0036 17.9947 26.0036C18.4087 26.0036 18.7444 25.6679 18.7444 25.2539V18.751L25.2522 18.7465C25.6662 18.7462 26.0017 18.4104 26.0014 17.9963C26.0011 17.5823 25.6652 17.2468 25.2512 17.2471Z" fill="#575CFF" />
                                                                            </g>
                                                                            <defs>
                                                                                <clipPath id="clip0_3731_33051">
                                                                                    <rect width="24" height="24" fill="white" transform="translate(6 6)" />
                                                                                </clipPath>
                                                                            </defs>
                                                                        </svg>

                                                                    </span>
                                                                    {inputList.length > 1 && (
                                                                        <span onClick={() => handleRemoveInput(index)}>
                                                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M6.92129 11.9564C6.64522 11.9564 6.42129 11.7324 6.42129 11.4564V5.74317C6.42129 5.46711 6.64522 5.24317 6.92129 5.24317C7.19735 5.24317 7.42129 5.46711 7.42129 5.74317V11.4564C7.42129 11.7324 7.19735 11.9564 6.92129 11.9564Z" fill="black" />
                                                                                <path d="M9.08142 11.9564C8.80535 11.9564 8.58142 11.7324 8.58142 11.4564V5.74317C8.58142 5.46711 8.80535 5.24317 9.08142 5.24317C9.35749 5.24317 9.58142 5.46711 9.58142 5.74317V11.4564C9.58142 11.7324 9.35749 11.9564 9.08142 11.9564Z" fill="black" />
                                                                                <path d="M13.448 2.97657H10.8145V2.56997C10.8145 1.86424 10.2585 1.29004 9.57489 1.29004H6.42122C5.73762 1.29004 5.18129 1.86424 5.18129 2.56997V2.97657H2.55469C2.27862 2.97657 2.05469 3.20051 2.05469 3.47657C2.05469 3.75264 2.27862 3.97657 2.55469 3.97657H2.95755L3.46909 12.4056C3.54395 13.698 4.61815 14.7103 5.91475 14.7103H10.0749C11.3705 14.7103 12.4506 13.6966 12.5339 12.4004L13.0458 3.97664H13.448C13.724 3.97664 13.948 3.75271 13.948 3.47664C13.948 3.20057 13.724 2.97657 13.448 2.97657ZM6.18135 2.56997C6.18135 2.41571 6.28909 2.29004 6.42129 2.29004H9.57495C9.70709 2.29004 9.81455 2.41571 9.81455 2.56997V2.97657H6.18142L6.18135 2.56997ZM11.5358 12.3379C11.4864 13.1074 10.8444 13.7103 10.0749 13.7103H5.91475C5.14749 13.7103 4.51142 13.112 4.46715 12.3464L3.95929 3.97657H12.0434L11.5358 12.3379Z" fill="black" />
                                                                            </svg>
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </Accordion.Body>
                                                    <div className={`btn-box ${styles.btnbox}`}>

                                                    </div>
                                                </Accordion.Item>
                                                <Accordion.Item eventKey="1">
                                                    <Accordion.Header>Outbound conditions </Accordion.Header>
                                                    <Accordion.Body>
                                                        {outboundList.map((input: any, index) => (
                                                            <div className={`initialcheck ${styles.initialcheck}`}>
                                                                <label className={`${styles.fieldarea} ${styles.fieldareablock}`}>
                                                                    <span>Prefix condition  &nbsp;
                                                                        <OverlayTrigger overlay={<Tooltip>Prefix condition Information</Tooltip>}>
                                                                            <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M6.24012 6.66686C6.44678 6.65353 6.92012 6.64686 7.26012 6.72686C7.50012 6.78686 7.66678 7.00686 7.65345 7.26019C7.64012 7.45353 7.59345 7.70019 7.53345 7.98019C7.44658 8.37111 7.38182 8.7753 7.33917 9.0415C7.32945 9.10211 7.32087 9.15568 7.31345 9.20019C7.26679 9.44019 7.35345 9.83353 7.66012 9.68019C7.96678 9.52686 8.24012 9.42686 8.14678 9.68019C8.06678 9.89353 7.64012 10.2002 7.14679 10.2202C6.65345 10.2402 6.04012 10.0269 6.10678 9.45353C6.15574 9.03252 6.2694 8.42459 6.33954 8.04944C6.36491 7.91374 6.3846 7.80842 6.39345 7.75353C6.39852 7.72213 6.40543 7.68626 6.41283 7.64785C6.45414 7.43347 6.51074 7.13977 6.34679 7.10019C6.29814 7.08845 6.24528 7.08093 6.19298 7.07349C6.03739 7.05135 5.88674 7.02992 5.86679 6.90019C5.84012 6.76686 5.97345 6.67352 6.25345 6.66019L6.24012 6.66686Z" fill="#757676" />
                                                                                <path d="M7.69345 5.47353C7.69345 5.85644 7.38304 6.16686 7.00012 6.16686C6.6172 6.16686 6.30678 5.85644 6.30678 5.47353C6.30678 5.09061 6.6172 4.78019 7.00012 4.78019C7.38304 4.78019 7.69345 5.09061 7.69345 5.47353Z" fill="#757676" />
                                                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.00016 0.833496C3.32016 0.833496 0.333496 3.82016 0.333496 7.50016C0.333496 11.1802 3.32016 14.1668 7.00016 14.1668C10.6802 14.1668 13.6668 11.1802 13.6668 7.50016C13.6668 3.82016 10.6802 0.833496 7.00016 0.833496ZM7.00016 1.8335C10.1268 1.8335 12.6668 4.3735 12.6668 7.50016C12.6668 10.6268 10.1268 13.1668 7.00016 13.1668C3.8735 13.1668 1.3335 10.6268 1.3335 7.50016C1.3335 4.3735 3.8735 1.8335 7.00016 1.8335Z" fill="#757676" />
                                                                            </svg>
                                                                        </OverlayTrigger>

                                                                    </span>
                                                                    <div className={styles.largeblock}>
                                                                        <div className={`inputfield ${styles.textareafield} ${styles.textareatag}`}>
                                                                            <div className="inputfieldflex inputfieldmultitag inputfieldmultitagip">
                                                                                <div className='taginput'>
                                                                                    {outboundList[index].pre_array.map((tag, tagIndex) => (<label className="taglabel" >{tag} <span>
                                                                                        <OverlayTrigger overlay={<Tooltip>Remove</Tooltip>}>
                                                                                            <div className='closebtn' onClick={() => outBoundRemoveTag(index, tagIndex)}>
                                                                                                <img src={cancelbtn} />
                                                                                            </div>
                                                                                        </OverlayTrigger>
                                                                                    </span>
                                                                                    </label>
                                                                                    ))}
                                                                                </div>
                                                                                <input className="errorinput" type="text" placeholder="Enter Condition"
                                                                                    value={outboundList[index].prefix}
                                                                                    onKeyDown={(evt) => outBoundHandleKeyDown(evt, index)}
                                                                                    onChange={(evt) => outBoundHandlePrifixChange(evt, index)}
                                                                                    onKeyPress={(event) => {
                                                                                        if (!/[0-9*+]/.test(event.key)) {
                                                                                            event.preventDefault();
                                                                                        }
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </label>

                                                                <label className={`${styles.fieldarea}  ${styles.fieldareablock}`}>
                                                                    <span>DID Numbers </span>
                                                                    <div className={styles.largeblock}>
                                                                        <div className={`inputfield ${styles.textareafield} ${styles.regularselectwidth} ${styles.textareatag} ${styles.textarearules}`}>

                                                                            <Select
                                                                                className="regularselect regularselectflex regularselectsiprule"
                                                                                menuShouldScrollIntoView={false}
                                                                                placeholder="Select DID"
                                                                                isMulti
                                                                                options={formattedOptions}
                                                                                onChange={(selected) => handleOutBoundChange(index, 'did', selected)}
                                                                                value={input.did}
                                                                                isSearchable={false}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </label>
                                                                <div className={`btn-box ${styles.btnbox}  ${styles.btnboxminus}`}>
                                                                    <span onClick={handleAddOutbound}>
                                                                        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <rect width="36" height="36" rx="18" fill="#F0F1F2" />
                                                                            <g clip-path="url(#clip0_3731_33051)">
                                                                                <path d="M25.2512 17.2471L18.7444 17.2516V10.7497C18.7444 10.3357 18.4087 10 17.9947 10C17.5807 10 17.245 10.3357 17.245 10.7497V17.2527L10.7472 17.2572C10.3332 17.2574 9.99775 17.5933 9.99805 18.0073C9.99835 18.4214 10.3342 18.7568 10.7482 18.7565L17.245 18.752V25.2539C17.245 25.6679 17.5807 26.0036 17.9947 26.0036C18.4087 26.0036 18.7444 25.6679 18.7444 25.2539V18.751L25.2522 18.7465C25.6662 18.7462 26.0017 18.4104 26.0014 17.9963C26.0011 17.5823 25.6652 17.2468 25.2512 17.2471Z" fill="#575CFF" />
                                                                            </g>
                                                                            <defs>
                                                                                <clipPath id="clip0_3731_33051">
                                                                                    <rect width="24" height="24" fill="white" transform="translate(6 6)" />
                                                                                </clipPath>
                                                                            </defs>
                                                                        </svg>

                                                                    </span>
                                                                    {outboundList.length > 1 && (
                                                                        <span onClick={() => handleRemoveOutbound(index)}>
                                                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M6.92129 11.9564C6.64522 11.9564 6.42129 11.7324 6.42129 11.4564V5.74317C6.42129 5.46711 6.64522 5.24317 6.92129 5.24317C7.19735 5.24317 7.42129 5.46711 7.42129 5.74317V11.4564C7.42129 11.7324 7.19735 11.9564 6.92129 11.9564Z" fill="black" />
                                                                                <path d="M9.08142 11.9564C8.80535 11.9564 8.58142 11.7324 8.58142 11.4564V5.74317C8.58142 5.46711 8.80535 5.24317 9.08142 5.24317C9.35749 5.24317 9.58142 5.46711 9.58142 5.74317V11.4564C9.58142 11.7324 9.35749 11.9564 9.08142 11.9564Z" fill="black" />
                                                                                <path d="M13.448 2.97657H10.8145V2.56997C10.8145 1.86424 10.2585 1.29004 9.57489 1.29004H6.42122C5.73762 1.29004 5.18129 1.86424 5.18129 2.56997V2.97657H2.55469C2.27862 2.97657 2.05469 3.20051 2.05469 3.47657C2.05469 3.75264 2.27862 3.97657 2.55469 3.97657H2.95755L3.46909 12.4056C3.54395 13.698 4.61815 14.7103 5.91475 14.7103H10.0749C11.3705 14.7103 12.4506 13.6966 12.5339 12.4004L13.0458 3.97664H13.448C13.724 3.97664 13.948 3.75271 13.948 3.47664C13.948 3.20057 13.724 2.97657 13.448 2.97657ZM6.18135 2.56997C6.18135 2.41571 6.28909 2.29004 6.42129 2.29004H9.57495C9.70709 2.29004 9.81455 2.41571 9.81455 2.56997V2.97657H6.18142L6.18135 2.56997ZM11.5358 12.3379C11.4864 13.1074 10.8444 13.7103 10.0749 13.7103H5.91475C5.14749 13.7103 4.51142 13.112 4.46715 12.3464L3.95929 3.97657H12.0434L11.5358 12.3379Z" fill="black" />
                                                                            </svg>
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                            </Accordion>
                                            <div className={`initialcheck ${styles.initialcheck} ${styles.active} ${styles.initialcheckcaller}`}>
                                                <h5>Caller ID</h5>
                                                <label className={`${styles.fieldarea} ${styles.fieldareablock} ${styles.fieldareacallerid}`}>
                                                    <span>Hide caller ID</span>
                                                    <div className={styles.largeblock}>
                                                        <div className={`inputfield ${styles.textareafield} ${styles.regularselectwidth} ${styles.textareatag} ${styles.textarearules}`}>
                                                            <Select
                                                                className="regularselect regularselectflex regularselectsiprule"
                                                                menuShouldScrollIntoView={false}
                                                                placeholder="Select DID"
                                                                isMulti
                                                                options={formattedOptions}
                                                                value={selectedValues}
                                                                onChange={handleSelectCallerID}
                                                                isSearchable={false}
                                                            />
                                                        </div>
                                                    </div>
                                                </label>
                                            </div>


                              
                            </div>
                    </div>
                    
                </Col>
            </Row>

            <Row className={`${styles.bottombtn} bottombtn`}>
                            <Col sm={12} className={styles.bottomareainner}>
                                <button onClick={BackPage} className="cancelbtn">Cancel</button>
                                {editTrunkId.SIPTrunkMasterId ?
                                    <button onClick={handleSubmit(upDateApi)} className="">Update</button>
                                    :
                                    <button onClick={handleSubmit(nextPage)} className="">Next</button>
                                }
                            </Col>
                        </Row>
        </>
    );
};

export default SipRules;
